import { Button, styled } from "@mui/material";

export const PushButton = styled(Button)(({ theme }) => ({
  maxHeight: "32px",
  padding: "8px 16px",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.main,
  ":hover": {
    backgroundColor: theme.palette.primary.main + " !important",
    color: "white !important",
  },
  "&.MuiButton-outlined": {
    border: "1px solid " + theme.palette.primary.main,
    background: "transparent",
    color: theme.palette.primary.main,
    ":hover": {
      border: "1px solid " + theme.palette.primary.main,
      color: theme.palette.primary.main,
    },
  },
}));

export const FilterIconButton = styled(PushButton)(() => ({
  padding: "8px",
}));

PushButton.defaultProps = {
  size: "small",
};

FilterIconButton.defaultProps = {
  size: "small",
};
